import { AddressGeoInfo } from '../../models/address-geo-info.dto';
import { GeoInfoRead } from '../../models/geo-info-read.model';
import { AddressHttp } from '../../models/address-http.dto';
import { Address } from '../../models/address.model';

export const addressFromAddressHttp = (addressHttp: AddressHttp): Address => {
  return {
    externalId: addressHttp.external_id,
    name: addressHttp.name,
    label: addressHttp.label,
    cityCode: addressHttp.city_code,
    cityPostalCode: addressHttp.city_postal_code,
    cityLabel: addressHttp.city_label,
    x: addressHttp.x,
    y: addressHttp.y,
    score: addressHttp.score,
    type: addressHttp.type,
  };
};

export const addressesFromAddressesHttp = (addressesHttp: {
  items: AddressHttp[];
}): Address[] => {
  return addressesHttp.items.map((addressHttp) =>
    addressFromAddressHttp(addressHttp),
  );
};

export const completeAddressFromAddressAndGeoReadInfo = (
  address: Address | undefined,
  geoInfoRead: GeoInfoRead | undefined,
  addressInput: string | undefined,
): AddressGeoInfo => {
  return {
    address_input: setAddressInput(address, geoInfoRead, addressInput),
    address_street: setAddressStreet(address),
    address_city_code: address?.cityCode,
    address_postal_code: address?.cityPostalCode,
    address_city: address?.cityLabel,
    address_x: address?.x,
    address_y: address?.y,
    address_type: address?.type,
    ...(address?.type === 'street' || address?.type === 'housenumber'
      ? {
          district_id: geoInfoRead?.districtId,
          district_label: geoInfoRead?.districtLabel,
        }
      : {}),
    city_id: geoInfoRead?.cityId,
    city_label: geoInfoRead?.cityLabel,
    epci_id: geoInfoRead?.epciId,
    epci_label: geoInfoRead?.epciLabel,
    departement_id: geoInfoRead?.departementId,
    departement_label: geoInfoRead?.departementLabel,
  };
};

function setAddressInput(
  address: Address | undefined,
  geoInfoRead: GeoInfoRead | undefined,
  addressInput: string | undefined,
) {
  return address && geoInfoRead ? undefined : addressInput;
}

function setAddressStreet(address: Address | undefined) {
  return address?.type === 'street' || address?.type === 'housenumber'
    ? address?.name
    : '';
}
